import React from "react";
import {getBannerInfo} from "../pages/bannerInfo";
import {appointmentBannerNotes} from "./appointmentBannerImport";
import {importAppointmentBannerInfo} from "./bannerData";

export default function AppointmentBannerInfo({job,appointment,editable,busy,run}) {
  if(!job.appointmentId)return null;
  const linked=appointment?.id===job.appointmentId,text=linked ? getBannerInfo(appointment) : "";
  let alreadyImported=false,problem="";
  if(text.trim()){try{alreadyImported=appointmentBannerNotes(job.notes,appointment).alreadyImported;}catch(error){problem=error.message;}}
  return <section className="banner-appointment-info" aria-label="Linked appointment Banner info"><details><summary>Banner info from linked photo appointment</summary>
    {!linked ? <p>The linked appointment is unavailable.</p> : !text.trim() ? <p>No Banner info recorded on the linked appointment.</p> : <>
      <p className="banner-note">{text}</p><p>Import appends this information to Written notes. Existing notes and the appointment are preserved.</p>
      {problem && <p role="alert">{problem}</p>}{alreadyImported && <p>This Banner info is already in the job notes.</p>}
      {editable && <button disabled={busy || alreadyImported || Boolean(problem)} onClick={()=>run(()=>importAppointmentBannerInfo(job.id,job.appointmentId,text,job.notes || ""),"Appointment Banner info imported into written notes.")}>Import Banner info into written notes</button>}
    </>}
  </details></section>;
}
